// Phase G G5 — pure viewer-page decisions (no network, no devices).

/** Pre-token gate: what the viewer route should do before minting a token. */
export type ViewerAccess =
  | { state: 'not_found' }
  | { state: 'not_live'; status: string }
  | { state: 'needs_signin' }
  | { state: 'authorize' };

/**
 * Decide the viewer access state from the resolved room + session presence.
 * Anonymous viewers are stopped before any token mint (anon → 401 anyway).
 */
export function decideViewerAccess(
  room: { status: string } | null | undefined,
  hasSession: boolean,
): ViewerAccess {
  if (!room) return { state: 'not_found' };
  if (room.status !== 'live') return { state: 'not_live', status: room.status };
  if (!hasSession) return { state: 'needs_signin' };
  return { state: 'authorize' };
}

/** In-player liveness: a brief program-track gap during `live` is a reconnect, not an end. */
export type Liveness = 'playing' | 'reconnecting' | 'ended';

export function livenessState(programPresent: boolean, roomStatus: string): Liveness {
  if (roomStatus === 'ended') return 'ended';
  return programPresent ? 'playing' : 'reconnecting';
}
